import api from './api';

const assetsDashboardService = {
  getDashboardStats: async () => {
    try {
      const response = await api.get('/assets-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching assets dashboard stats:', error);
      throw error;
    }
  },
};

export default assetsDashboardService;
